import { render, staticRenderFns } from "./NameDisplay.vue?vue&type=template&id=b1a57308&"
import script from "./NameDisplay.vue?vue&type=script&lang=js&"
export * from "./NameDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports